export default function () {

  return function emailsFilter(emails = '') {
    return emails.join(', ');
  };
}



// WEBPACK FOOTER //
// ./src/filters/emailsFilter.js